<template>
    <div>
        <div style="margin-top:50px;margin-left:50px;margin-right:50px;">
            <el-table
            :data="request_info"
            style="width:100%"
            stripe
            border>
                <el-table-column type="index"></el-table-column>
                <el-table-column prop="request_time" label="申请日期" min-width="12%"></el-table-column>
                <el-table-column prop="name" label="专家姓名" min-width="12%"></el-table-column>
                <el-table-column prop="contact" label="联系方式" min-width="12%"></el-table-column>
                <el-table-column prop="field" label="擅长领域" min-width="16%" show-overflow-tooltip></el-table-column>
                <el-table-column prop="career" label="工作履历" min-width="30%" show-overflow-tooltip></el-table-column>
                <el-table-column prop="status" label="状态" min-width="8%"></el-table-column>
                <el-table-column prop="operations" label="操作" min-width="10%">
                    <template slot-scope="scope">
                        <el-button
                        type="text"
                        style="color:#67C23A;font-weight:bold;"
                        :disabled="scope.row.status=='已接受' || scope.row.status=='已拒绝'"
                        @click="handleAccept(scope.row.id)">接受</el-button>
                        <el-button
                        type="text"
                        style="color:#F56C6C;font-weight:bold;"
                        :disabled="scope.row.status=='已接受' || scope.row.status=='已拒绝'"
                        @click="handleReject(scope.row.id)">拒绝</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="margin-top:10px;" v-if="request_info.length > 0">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageinfo.current"
                    :page-sizes="pageinfo.page_sizes"
                    :page-size="pageinfo.page_size"
                    layout="total, sizes, prev, pager, next"
                    :total="pageinfo.count">
                </el-pagination>
            </div>
            <el-dialog
            title="填写拒绝理由"
            :visible.sync="dialogVisible"
            width="30%"
            class="rejuect_reason_dialog">
                <el-input v-model="reject_reason" type="textarea" :rows="3"></el-input>
                <div style="margin-top:15px;">
                    <el-button type="primary" size="mini" @click="rejuectApprove">提交</el-button>
                    <el-button type="primary" size="mini" @click="cancel_reject">取消</el-button>
                </div>
            </el-dialog>
            <!-- <el-dialog
            :visible.sync="dialogVisible"
            :fullscreen="true"
            :show-close="false"
            custom-class="fullscreen-dialog">
            <template #title>
                <div class="dialog-header">
                <span>{{ dialog_title }}</span>
                <el-button
                    class="close-btn"
                    icon="el-icon-close"
                    @click="dialogVisible = false"
                ></el-button>
                </div>
            </template>

            <div class="dialog-content">
                <div style="margin-left:50px;margin-right:50px;margin-top:10px;">
                    <el-table
                    :data="details_info"
                    style="width:100%"
                    stripe
                    border
                    @selection-change="handleSelectionChange">
                        <el-table-column type="selection" min-width="5%" v-if="dialog_title=='配置痛点'"></el-table-column>
                        <el-table-column type="index"></el-table-column>
                        <el-table-column :key="index" v-for="(col, index) in details_columns" :prop="col.name" :label="col.label" :min-width="col.min_width"></el-table-column>
                    </el-table>
                    <el-button type="primary" @click="savePainSpotConfig" v-if="dialog_title=='配置痛点'" style="margin-top:30px;margin-left:50px;">保存</el-button>
                </div>
            </div>
            </el-dialog> -->
        </div>
    </div>
</template>

<script>
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";

export default {
    created() {
        this.getExpertApproveList();
    },
    data() {
        return {
            // dialog_title: '',
            dialogVisible: false,
            // search_name: '',
            // search_role: '',
            request_info: [],
            // request_info: [
            //     {'request_time': '2025-05-12', 'nickname': '付寅', 'contact': '15305166919', 'field': '收到防守打法水电费萨芬啊', 'career': '实打实大师大师大师大苏打萨达撒大声地阿萨德阿萨德阿萨德阿萨德阿萨德阿萨德阿萨德阿萨德阿萨德阿萨德暗杀大叔大声道阿萨德阿萨德阿萨德阿萨德暗杀的奥德赛阿萨德', 'status': '已接受'},
            //     {'request_time': '2025-05-13', 'nickname': '付寅', 'contact': '15305166919', 'field': '收到防守打法水电费萨芬啊', 'career': '实打实大师大师大师大苏打萨达撒大声地阿萨德阿萨德阿萨德阿萨德阿萨德阿萨德阿萨德阿萨德阿萨德阿萨德暗杀大叔大声道阿萨德阿萨德阿萨德阿萨德暗杀的奥德赛阿萨德', 'status': '已拒绝'},
            //     {'request_time': '2025-05-14', 'nickname': '付寅', 'contact': '15305166919', 'field': '收到防守打法水电费萨芬啊', 'career': '实打实大师大师大师大苏打萨达撒大声地阿萨德阿萨德阿萨德阿萨德阿萨德阿萨德阿萨德阿萨德阿萨德阿萨德暗杀大叔大声道阿萨德阿萨德阿萨德阿萨德暗杀的奥德赛阿萨德', 'status': '待处理'}],
            pageinfo: {
                count: 0,
                current: 1,
                page_size: 20,
                page_sizes: [1, 10, 20, 50, 100],
            },
            reject_reason: '',
            reject_id: -1,
            // details_info: [
            //     {'id': 1, 'title': '痛点1', 'datetime': '2025-03-14'}, 
            //     {'id': 3, 'title': '痛点2', 'datetime': '2025-04-12'},
            //     {'id': 5, 'title': '痛点3', 'datetime': '2025-02-11'},
            //     {'id': 7, 'title': '痛点4', 'datetime': '2025-05-24'},
            //     {'id': 9, 'title': '痛点5', 'datetime': '2025-05-05'}],
            // details_columns: [],
            // selectedRows: [],
        }
    },
    methods: {
        handleSizeChange: function(size) {
            // 这里的size还有下面的currentPage都是系统自动识别到的，直接使用即可
            this.pageinfo.page_size = size;
            this.pageinfo.current = 1;
            // console.log('page_size: ' + this.pageinfo.page_size);
            this.getExpertApproveList();
            // console.log(this.pageinfo.page_size)
            // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        },
        handleCurrentChange: function(currentPage) {
            this.pageinfo.current = currentPage;
            // console.log('current: ' + this.pageinfo.current);
            this.getExpertApproveList();
            // console.log(this.pageinfo.current)
            // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        },
        handleAccept(rid) {
            let params;
            params = {
                id: rid,
            }
            getdata.getListP("acceptExpertApprove", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.$message({
                    message: resp.data.message,
                    type: 'success',
                    }) 
                    this.getExpertApproveList();         
                }else{
                    this.$message({
                    message: resp.data.message,
                    type: 'error',
                    duration: 6000,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        handleReject(rid) {
            this.reject_reason = '';
            this.reject_id = rid;
            this.dialogVisible = true;
        },
        rejuectApprove() {
            let params;
            params = {
                id: this.reject_id,
                reject_reason: this.reject_reason
            }
            getdata.getListP("rejectExpertApprove", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.$message({
                    message: resp.data.message,
                    type: 'success',
                    }) 
                    this.dialogVisible = false;
                    this.getExpertApproveList();         
                }else{
                    this.$message({
                    message: resp.data.message,
                    type: 'error',
                    duration: 6000,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        cancel_reject() {
            this.dialogVisible = false;
        },
        getExpertApproveList() {
            let params;
            params = {
                start: (this.pageinfo.current - 1) * this.pageinfo.page_size,
                end: (this.pageinfo.current) * this.pageinfo.page_size,
            }
            getdata.getListP("getExpertApproveList", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.request_info = resp.data.data;
                    this.pageinfo.count = resp.data.count;          
                }
            })
            .catch(err => {
                console.log(err);
            });
        }
    }
}
</script>

<style scoped>
/* ::v-deep .el-input__inner {
    height: 28px;
    line-height: 28px;
}
::v-deep .el-select .el-input .el-select__caret {
    line-height: 28px;
} */
::v-deep .el-table th {
    line-height: 30px;
    padding: 0; /* 可选：减少默认内边距 */
}
::v-deep .el-table__row td {
    line-height: 30px;
    padding: 0; /* 可选：减少默认内边距 */
}
.rejuect_reason_dialog /deep/ .el-dialog__header {
    text-align: left;
}
.el-button--text.is-disabled {
  color: #c0c4cc !important;
}
</style>